export default function commentCard(comment) {
    return /* html */ "\n    <div class=\"card comment-card\">\n        <div class=\"card-body\">\n            <h5 class=\"card-comment-title\">" + comment.name + "</h5>\n            <h6 class=\"card-subtitle\">" + comment.email + "</h6>\n            <p class=\"card-text\">" + comment.body + "</p>\n        </div>\n    </div>\n    ";
}
